import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import { configure } from "mobx";

import './icons';
import './styles/index.css';
import registerServiceWorker from './registerServiceWorker';
import store from './store';
import config from './config';

import Home from './screens/Home';

import eventListeners from './eventListeners';

const url = new URL(window.location.href);

config.token = url.searchParams.get('token');
config.writeAccess = url.searchParams.get('write_access') === '1';

configure({ enforceActions: 'always' });

eventListeners(store);

ReactDOM.render((
  <Provider {...store}>
    <Home />
  </Provider>
), document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js